export const dashboardStyles = {
  root: {
    flexGrow: 1,
    p: 2,
    bgcolor: 'rgb(0, 0, 0)',
    minHeight: '100vh'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    mb: 5
  },
  title: {
    color: 'rgb(255, 255, 255)',
    fontSize: '1.25rem',
    fontWeight: 700,
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    mb: 2
  },
  gridContainer: {
    spacing: 2
  }
};

export const cardStyles = {
  root: {
    bgcolor: 'rgb(10, 10, 10)',
    backgroundImage: 'none',
    borderRadius: 1,
    border: '1px solid rgba(145, 158, 171, 0.12)',
    boxShadow: 'none',
    overflow: 'hidden',
    height: '100%',
    '& .MuiCardContent-root': {
      p: '24px 16px'
    }
  },
  content: {
    p: 3
  }
};

export const chartContainerStyles = {
  root: {
    p: 0
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    mb: 2
  },
  title: {
    color: 'rgb(255, 255, 255)',
    fontSize: '1rem',
    fontWeight: 700,
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    mb: 0.5
  },
  subtitle: {
    color: 'rgb(145, 158, 171)',
    fontSize: '0.875rem',
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    lineHeight: 1.5
  },
  chartWrapper: {
    height: 360,
    width: '100%',
    mt: 2
  }
}; 